<template>
  <div :class="{contentWrap:true,noTab:isShow,noNav:$store.state.isWx}">
    <div class="container">
      <van-nav-bar
        style="z-index: 999"
        :title="title"
        left-arrow
        fixed
        v-if="!$store.state.isWx"
        @click-left="onClickLeft"
      />
      <scroll>
        <div class="wrap onPxBottom lH60 alignCenter itemList">
          <van-row type="flex">
            <van-col span="5">开票信息</van-col>
          </van-row>
          <van-cell-group v-if="invoiceMsg.typeRadio== 0">
            <van-row>
              <van-col span="4">选择</van-col>
              <van-col span="9">订单号/票号</van-col>
              <van-col span="7">票名/数量</van-col>
              <van-col span="4">小计</van-col>
            </van-row>
          </van-cell-group>
          <van-cell-group v-for="(pitem, pindex)  in invoiceMsg.pitemList" :key="pitem.orderNumber">
            <van-row v-if="pitem.typeRadio != 0">
              <van-col span="6">
                <span v-if="pitem.typeRadio == 2">票号</span>
                <span v-else>订单号</span>
              </van-col>
              <van-col span="12">票名/价格/数量</van-col>
              <van-col span="6">小计</van-col>
            </van-row>

            <van-row v-for="(item, index) in pitem.ticketList" :key="item.ticketName">
              <van-col span="24" class="nextItemList">
                <van-cell-group @click="checkboxChange(pitem, pindex)">
                  <van-row v-if="index==0">
                    <van-col span="2" v-if="pitem.typeRadio==0">
                      <!--<input type="checkbox" v-model="pitem.checked" ref="checkboxes"  name="all"/>-->
                      <van-checkbox
                        v-model="pitem.checked"
                        ref="checkboxes"
                        @click="checkboxChange(pitem, pindex)"
                      ></van-checkbox>
                    </van-col>
                    <van-col span="6" v-if="pitem.typeRadio==0">**{{pitem.orderNumber.substr(-4)}}</van-col>
                    <van-col span="6" v-else>**{{pitem.orderNumber.substr(-4)}}</van-col>

                    <van-col span="12">
                      <span style="font-size: .15rem;">{{`${item.ticketName}`}} {{`x ${item.ticketCount}`}}</span>
                    </van-col>
                    <van-col span="6">
                      <span style="color: red">{{item.ticketMoney.toFixed(2)}}</span>
                    </van-col>
                  </van-row>

                  <van-row v-else>
                    <van-col span="10">&nbsp;</van-col>
                    <van-col span="8">
                      <span style="font-size: .13rem;">{{`${item.ticketName}`}} {{`x ${item.ticketCount}`}}</span>
                    </van-col>
                    <van-col span="5">
                      <span style="color: red">{{item.ticketMoney.toFixed(2)}}</span>
                    </van-col>
                  </van-row>
                </van-cell-group>
              </van-col>
            </van-row>
          </van-cell-group>
        </div>
        <div class="wrapTitle">发票详情（必填）</div>
        <van-tabs v-model="active">
          <van-tab title="个人发票"></van-tab>
          <van-tab title="企业发票"></van-tab>
        </van-tabs>
        <van-cell-group>
          <van-field
            v-model="invoiceForm.header"
            clearable
            label="发票抬头"
            @blur="headerIsRight"
            :error-message="headerErrorMsg"
            placeholder="填写发票抬头（必填）"
          />
          <van-field
            v-show="active==1"
            v-model="invoiceForm.company"
            clearable
            label="税号"
            @blur="companyIsRight"
            :error-message="companyErrorMsg"
            placeholder="填写纳税人识别编号（必填）"
          />
          <van-field
            v-model="invoiceForm.phone"
            clearable
            @blur="phoneIsRight"
            :error-message="phoneErrorMsg"
            label="联系电话"
            placeholder="请输入联系电话（必填）"
          />
          <van-field
            v-model="invoiceForm.address"
            clearable
            label="联系地址"
            placeholder="请输入联系地址（选填）"
          />
          <van-field
            v-show="active==1"
            v-model="invoiceForm.ghfkhh"
            clearable
            label="开户行"
            placeholder="请输入开户行（选填）"
          />
          <van-field
            v-model="invoiceForm.ghfyhzh"
            clearable
            label="银行账户"
            placeholder="请输入银行账户（选填）"
          />
        </van-cell-group>

        <div class="wrap onPxBottom lH80 alignCenter">
          <van-row type="flex">
            <van-col span="7">发票内容</van-col>
            <van-col span="18">
              <div class="alignLeft" style="color: #0088cc">{{invoiceMsg.contentMsg}}</div>
            </van-col>
          </van-row>
        </div>
        <div class="wrap onPxBottom lH80 alignCenter">
          <van-row type="flex">
            <van-col span="7">发票金额</van-col>
            <van-col span="18">
              <div class="alignLeft">
                <span style="color: red;font-weight: bolder">￥{{invoiceMsg.invoiceMoney}}</span>
                <span style="font-size: .20rem;color: red">元</span>
              </div>
            </van-col>
          </van-row>
        </div>
        <div class="wrapTitle">接受方式(选填)</div>
        <div class="invoiceWrap boxShadow">
          <van-cell-group>
            <van-field
              v-model="invoiceForm.email"
              clearable
              label="邮箱地址"
              @blur="emailIsRight"
              :error-message="emailErrorMsg"
              placeholder="接受电子发票的邮箱地址"
            />
          </van-cell-group>
        </div>
        <div class="buttonWrap">
          <van-button type="primary" @click="firstConfirm">提交</van-button>
        </div>
      </scroll>
    </div>
    <van-popup v-model="isShow" position="bottom" :overlay="true">
      <div style="width: 100%;overflow: hidden;z-index: 1000">
        <div class="closeWrap">
          <van-row type="flex">
            <van-col span="4">
              <div @click="isShow=false">
                <i class="fa fa-times" aria-hidden="true"></i>
              </div>
            </van-col>
            <van-col span="16">确认开具电子发票</van-col>
            <van-col span="4"></van-col>
          </van-row>
        </div>
        <div class="confirmWrap onPxBottom">
          <van-row type="flex">
            <van-col span="7">
              <div class="labelTitle">发票类型</div>
            </van-col>
            <van-col span="17">
              <div class="titleContent">{{active?'企业发票':'个人发票'}}</div>
            </van-col>
          </van-row>
        </div>
        <div class="confirmWrap onPxBottom">
          <van-row type="flex">
            <van-col span="7">
              <div class="labelTitle">发票抬头</div>
            </van-col>
            <van-col span="17">
              <div class="titleContent">{{invoiceForm.header}}</div>
            </van-col>
          </van-row>
        </div>
        <div class="confirmWrap onPxBottom" v-if="active">
          <van-row type="flex">
            <van-col span="7">
              <div class="labelTitle">税号</div>
            </van-col>
            <van-col span="17">
              <div class="titleContent">{{invoiceForm.company}}</div>
            </van-col>
          </van-row>
        </div>
        <div class="confirmWrap onPxBottom" v-if="invoiceForm.phone">
          <van-row type="flex">
            <van-col span="7">
              <div class="labelTitle">联系电话</div>
            </van-col>
            <van-col span="17">
              <div class="titleContent">{{invoiceForm.phone}}</div>
            </van-col>
          </van-row>
        </div>
        <div class="confirmWrap onPxBottom" v-if="invoiceForm.address">
          <van-row type="flex">
            <van-col span="7">
              <div class="labelTitle">联系地址</div>
            </van-col>
            <van-col span="17">
              <div class="titleContent">{{invoiceForm.address}}</div>
            </van-col>
          </van-row>
        </div>
        <div class="confirmWrap onPxBottom" v-if="invoiceForm.ghfkhh">
          <van-row type="flex">
            <van-col span="7">
              <div class="labelTitle">开户行</div>
            </van-col>
            <van-col span="17">
              <div class="titleContent">{{invoiceForm.ghfkhh}}</div>
            </van-col>
          </van-row>
        </div>
        <div class="confirmWrap onPxBottom" v-if="invoiceForm.ghfyhzh">
          <van-row type="flex">
            <van-col span="7">
              <div class="labelTitle">银行账户</div>
            </van-col>
            <van-col span="17">
              <div class="titleContent">{{invoiceForm.ghfyhzh}}</div>
            </van-col>
          </van-row>
        </div>
        <div class="confirmWrap onPxBottom">
          <van-row type="flex">
            <van-col span="7">
              <div class="labelTitle">发票内容</div>
            </van-col>
            <van-col span="17">
              <div class="titleContent">{{invoiceMsg.contentMsg}}</div>
            </van-col>
          </van-row>
        </div>
        <div class="confirmWrap onPxBottom">
          <van-row type="flex">
            <van-col span="7">
              <div class="labelTitle">发票金额</div>
            </van-col>
            <van-col span="17">
              <div class="titleContent">
                <span style="color: red;font-weight: bolder">￥{{invoiceMsg.invoiceMoney}}</span>
                <span style="font-size: .20rem;color: red">元</span>
              </div>
            </van-col>
          </van-row>
        </div>
        <div class="confirmWrap onPxBottom">
          <van-row type="flex">
            <van-col span="7">
              <div class="labelTitle">电子邮箱</div>
            </van-col>
            <van-col span="17">
              <div class="titleContent">{{invoiceForm.email === ''?'无':invoiceForm.email}}</div>
            </van-col>
          </van-row>
        </div>
        <div class="buttonWrap">
          <van-button type="primary" @click="submitData">确认提交</van-button>
        </div>
      </div>
    </van-popup>
    <van-dialog
      v-model="isSuccess"
      @confirm="toDetail"
      style="z-index: 999"
      confirm-button-text="查询发票"
    >
      <div style="text-align: center;padding: 10px">
        <i class="fa fa-thumbs-o-up" aria-hidden="true" style="color: green;font-size: 1rem"></i>
        <br />
        <span style="font-size: .20rem;color: green">感谢使用电子发票，为环保贡献一份力量，为您点赞！</span>
      </div>
    </van-dialog>
  </div>
</template>
<style>
.itemList [class*="van-hairline"]::after {
  border-bottom: 1px solid #f2f2f2 !important;
}
.nextItemList [class*="van-hairline"]::after {
  border-bottom: 0 solid #f2f2f2 !important;
  border-width: 0;
}
</style>

<script>
export default {
  name: "invoiceAdd",
  data() {
    return {
      isShow: false,
      isSuccess: false,
      active: 0,
      title: this.$route.meta.title,
      orderPhone:"",
      checked: true,
      invoiceMsg: {
        orderNumber: "",
        orderName: "",
        contentMsg: "",
        invoiceMoney: "",
        id: "",
        type: "",
        checked: true,
        typeRadio: 0,
        pitemList: [],
        ticketList: [],
      },
      invoiceForm: {
        header: "",
        company: "",
        phone: "",
        email: "",
        ghfkhh: "",
        ghfyhzh: "",
        address:""
      },
      emailErrorMsg: "",
      headerErrorMsg: "",
      companyErrorMsg: "",
      phoneErrorMsg: "",
    };
  },
  created() {
    // this.getData()
    const dataP = JSON.parse(this.$route.query.data);
    this.orderPhone=this.$route.query.phone;
    let _this = this;
    //console.log( "dataP")
    //console.log( dataP)

    let newArr = [];

    let invoiceMoney = 0;

    for (let m = 0; m < dataP.length; m++) {
      const data = dataP[m][0];
      //console.log("data.typeRadio===")
      //console.log(data.typeRadio !== 0)
      if (data.typeRadio !== 0) {
        _this.invoiceForm.phone = data.phone;
        _this.invoiceMsg = {
          orderNumber: data.orid,
          orderName: data.ticketName,
          contentMsg: "文化服务",
          invoiceMoney: data.fpmoney.toFixed(2),
          type: data.vtype,
          typeRadio: data.typeRadio,
        };
        if (data.vtype === "02") {
          _this.invoiceMsg.num = data.tcount;
        }
        console.log(data.vtype);
      } else {
        _this.invoiceMsg = {
          contentMsg: "文化服务",
          invoiceMoney: "0.00",
          type: "02",
          typeRadio: 0,
        };
      }
      const list = dataP[m].splice(1);

      newArr.push({
        orderNumber: data.orid,
        orderName: data.ticketName,
        contentMsg: "文化服务",
        invoiceMoney: data.fpmoney.toFixed(2),
        type: data.vtype,
        typeRadio: data.typeRadio,
        checked: true,
        ticketList: [...list],
      });
    }
    //console.log( "pitemList")
    //console.log( newArr)
    this.checked = true;
    _this.invoiceMsg.pitemList = [...newArr];
    let orderNumbes = [];

    this.invoiceMsg.pitemList.forEach(function (e, i) {
      if (e.checked) {
        invoiceMoney += e.invoiceMoney * 1;
        orderNumbes.push(e.orderNumber);
      }
    });
    this.invoiceMsg.invoiceMoney = invoiceMoney.toFixed(2);

    this.invoiceMsg.orderNumber = orderNumbes.join("@"); //初始全选
    //console.log( _this.invoiceMsg)
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },

    async ajaxData() {
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        message: "提交中...",
        className: "toastIndex",
      });
      const parmas = {
        buyerName: this.invoiceForm.header,
        invoiceCategory: this.active === 0 ? 1 : 2,
        buyerTaxpayerNum: this.invoiceForm.company,
        buyerTel: this.invoiceForm.phone,
        orderNo: this.invoiceMsg.orderNumber,
        invoiceMoney: this.invoiceMsg.invoiceMoney,
        buyerEmail: this.invoiceForm.email,
        invoiceType: this.invoiceMsg.type,
        orderTel:this.orderPhone == "" ? this.invoiceForm.phone : this.orderPhone,
        buyerAddress:this.invoiceForm.address,
        buyerBankName: this.invoiceForm.ghfkhh,
        buyerBankAccount: this.invoiceForm.ghfyhzh,
      };
      const data = await this.$http.createIncoice(parmas);
      if (data.status === "error") {
        this.$toast.clear();
        alert(data.message);
        this.isShow = false;
      } else {
        this.$toast.clear();
        this.isSuccess = true;
      }
    },
    phoneIsRight() {
      this.phoneErrorMsg = "";
      const writerStr = this.invoiceForm.phone;
      /* eslint-disable*/
      if (writerStr == "") {
        this.phoneErrorMsg = "联系电话不能为空！";
        return false;
      } else {
        var filter = /^((13[0-9])|(14[0,1,4-9])|(15[0-3,5-9])|(16[2,5,6,7])|(17[0-8])|(18[0-9])|(19[0-3,5-9]))\d{8}$/;
        if (writerStr !== "" && !filter.test(writerStr)) {
          this.phoneErrorMsg = "联系电话格式不正确！";
          return false;
        } else {
          return true;
        }
      }
    },
    emailIsRight() {
      this.emailErrorMsg = "";
      const writerStr = this.invoiceForm.email;
      /* eslint-disable*/
      var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      if (writerStr !== "" && !filter.test(writerStr)) {
        this.emailErrorMsg = "您的邮箱格式不正确！";
        return false;
      } else {
        return true;
      }
    },
    headerIsRight() {
      const writerStr = this.invoiceForm.header;
      this.headerErrorMsg = "";
      if (writerStr == "") {
        this.headerErrorMsg = "抬头不能为空！";
        return false;
      } else {
        return true;
      }
    },
    companyIsRight() {
      if (this.active) {
        this.companyErrorMsg = "";
        const writerStr = this.invoiceForm.company;
        if (writerStr == "") {
          this.companyErrorMsg = "税号不能为空！";
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    checkchooseItem() {
      if (this.invoiceMsg.invoiceMoney * 1 == 0) {
        this.headerErrorMsg = "请至少选择一项！";
        return false;
      } else {
        return true;
      }
    },
    firstConfirm() {
      if (
        this.checkchooseItem() &&
        this.companyIsRight() &&
        this.headerIsRight() &&
        this.emailIsRight()
      ) {
        this.isShow = true;
      }
    },
    toDetail() {
      // this.$router.push(`/invoiceDetail/${this.invoiceMsg.orderNumber}`)
      this.$router.push(`/`);
    },
    submitData() {
      this.ajaxData();
    },
    checkboxClick(e) {
      /*let p = e.target.parentElement

        if(p.getAttribute("class").indexOf("van-checkbox__icon--checked")!=-1) {

          p.setAttribute("class", p.getAttribute("class").replace("van-checkbox__icon--checked"))
        } else {
          p.setAttribute("class", p.getAttribute("class")+" van-checkbox__icon--checked")
        }*/
    },
    checkboxChange(pitem, pindex) {
      //console.log(this.invoiceMsg.pitemList)

      let p = this.$refs.checkboxes[pindex].$el.firstChild;
      let c = false;

      if (
        p.getAttribute("class").indexOf("van-checkbox__icon--checked") != -1
      ) {
        p.setAttribute(
          "class",
          p.getAttribute("class").replace("van-checkbox__icon--checked")
        );
        c = false;
      } else {
        p.setAttribute(
          "class",
          p.getAttribute("class") + " van-checkbox__icon--checked"
        );
        c = true;
      }
      this.invoiceMsg.pitemList[pindex].checked = c;
      // console.log(this.invoiceMsg.pitemList[pindex].checked)

      let orderNumbes = [];
      let invoiceMoney = 0;
      this.invoiceMsg.pitemList.forEach(function (e, i) {
        if (e.checked) {
          orderNumbes.push(e.orderNumber);
          invoiceMoney += e.invoiceMoney * 1;
        }
      });

      //console.log(invoiceMoney)

      this.invoiceMsg.orderNumber = orderNumbes.join("@");
      this.invoiceMsg.invoiceMoney = invoiceMoney.toFixed(2);

      //console.log(this.invoiceMsg.orderNumber)
    },
  },
};
</script>

<style scoped>
.invoiceWrap .labelTitle {
  font-weight: normal;
}

.labelTitle {
  font-size: 0.24rem;
  text-align: center;
}

.titleContent {
  font-size: 0.24rem;
  text-align: left;
}

.copyright {
  margin-top: 0.3rem;
  padding-top: 0.1rem;
  border-top: 0.02rem solid #d7d7d7;
  font-size: 0.2rem;
  color: #9ca5a9;
  text-align: center;
  line-height: 0.45rem;
}

.buttonWrap {
  font-size: 0.22rem;
  text-align: center;
  padding: 0.2rem;
  margin-top: 0.4rem;
}

.closeWrap {
  background-color: #f2f2f2;
  height: 40px;
  font-size: 0.26rem;
  line-height: 40px;
  text-align: center;
}

.closeWrap i {
  position: relative;
  top: 0.05rem;
  font-size: 0.36rem;
}

.confirmWrap {
  position: relative;
  line-height: 0.8rem;
}
</style>


// WEBPACK FOOTER //
// src/page/InvoiceAdd.vue